module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'filter',
    ],
}